import React from "react";
import { useTranslation } from "react-i18next";
import { CopyIcon } from "../../../assets/icons";
import { handleCopy } from "../../../utils";
import styles from "./CopyableRow.module.scss";

interface CopyableRowProps {
	label: string;
	value: string;
	className?: string;
}

export const CopyableRow: React.FC<CopyableRowProps> = ({ label, value, className = "" }) => {
	const { t } = useTranslation();
	return (
		<div className={`${styles.wrapper} ${className}`}>
			<span className={styles.label}>{label}</span>
			<div className={styles.row}>
				<span className={styles.value}>{value}</span>
				<button type="button" className={styles.copyButton} onClick={() => handleCopy(value)}>
					<CopyIcon />
					{t("common.actions.copy")}
				</button>
			</div>
		</div>
	);
};
